// Header.js
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

export function useTabManager(initial) {
  const [activeTab, setActiveTab] = useState(initial)
  const isActive = tabKey => activeTab === tabKey
  return { activeTab, setActiveTab, isActive }
}

export function Header({
  tabs,
  initialTab,
  onTabChange,
  registerHref = '/register'
}) {
  const { activeTab, setActiveTab, isActive } = useTabManager(initialTab)

  // Notify parent when activeTab changes
  useEffect(() => {
    if (onTabChange) onTabChange(activeTab)
  }, [activeTab, onTabChange])

  // Scroll‐to‐section handler
  function handleScrollTo(e, tab) {
    e.preventDefault()
    const section = document.getElementById(tab.key)
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' })
      setActiveTab(tab.key)
    }
  }

  return (
    <header className="site-header">
      <nav className="site-nav">
        <ul>
          {tabs.map(tab => (
            <li key={tab.key}>
              <a
                href={`#${tab.key}`}
                className={isActive(tab.key) ? 'active' : ''}
                onClick={e => handleScrollTo(e, tab)}
              >
                {tab.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      {/* <a href={registerHref} className="btn-register">
        Register Now
      </a> */}
    </header>
  )
}

Header.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key:   PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  initialTab:   PropTypes.string,
  onTabChange:  PropTypes.func,
  registerHref: PropTypes.string
}

Header.defaultProps = {
  initialTab:  'about',
  onTabChange: null,
  registerHref: '/register'
}
